import React from 'react';
import "./Profile.css";
import ProfileSidebar from "./ProfileSidebar";
import ProfileInfo from "./ProfileInfo";
import { useParams } from "react-router-dom";
import ProfileMain from "./ProfileMain";

function Profile() {
    const {username, uid} = useParams();

    return (
        <div className="profile">
            <ProfileSidebar uid={uid}/>
            <ProfileMain username={username} uid={uid} />
            <ProfileInfo username={username} uid={uid} />
        </div>
    )
}

export default Profile;